import React from 'react';
import HeroAndHowItWorksSection from '../components/home/HeroSection';
import Features from '../components/home/Features';
import Feedback from '../components/home/Feedback';
import ContactUs from '../components/home/ContactUs';
import FAQ from '../components/home/FAQ';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroAndHowItWorksSection />
      <Features />
      <Feedback />
      <ContactUs />
      <FAQ />
    </div>
  );
};

export default Home; 